import { checkType } from './utils/functions'

const localStorage = global.localStorage
let memoryStorage = {}

export default Object.freeze({
  setItem(key, value) {
    checkType(key, value)

    memoryStorage[key] = value
    localStorage.setItem(key, JSON.stringify(value))
  },
  getItem(key) {
    try {
      if (!memoryStorage[key]) {
        memoryStorage[key] = JSON.parse(localStorage.getItem(key))
      }
    } catch (error) {
      console.error(`localStorage formatter error: key=${key} option=${option}`)
    }
    return memoryStorage[key]
  },
  removeItem(key) {
    if (memoryStorage[key]) {
      delete memoryStorage[key]
    }
    localStorage.removeItem(key)
  },
  clear() {
    memoryStorage = {}
    localStorage.clear()
  },
})
